import { SharedModule } from './../../shared/shared.module'
import { NgxPermissionsModule } from 'ngx-permissions'
import { RouterModule } from '@angular/router'
import { PropertyTypeModalComponent } from './property-type-modal.component'
import { NgSelectModule } from '@ng-select/ng-select'
import { CommonModule } from '@angular/common'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgModule } from '@angular/core'
import { ContentEditableModule } from '@containers/i18n/content-editable/content-editable.module'
import { TranslateModule } from '@ngx-translate/core'

@NgModule({
  declarations: [PropertyTypeModalComponent],
  imports: [
    CommonModule,
    SharedModule,
    BrowserAnimationsModule,
    TranslateModule,
    ContentEditableModule,
  ],
  exports: [PropertyTypeModalComponent],
})
export class PropertyTypeModalModule {}
